import { useState } from "react";
import Modal from "../components/Modal";
import Field, { inputStyle, selectStyle } from "../components/Field";
import { CONTRACT_STATUSES, SERVICES } from "../constants";
import { generateId, getToday, maskCurrency, unmaskCurrency } from "../utils";

export default function NewContract({ open, onClose, setContracts, clients, userId }) {
  const [form, setForm] = useState({
    clientId: "", type: "mensal", value: "", startDate: "", endDate: "",
    services: [], notes: "", renewalDate: "",
  });

  const wonClients = (clients || []).filter((c) => c.stage === "ganho");
  const selectedClient = wonClients.find((c) => c.id === form.clientId);

  const handleSave = () => {
    if (!form.clientId || !form.startDate || !form.endDate) return;
    const contract = {
      id: generateId(), userId,
      clientId: form.clientId,
      clientName: selectedClient?.company || "",
      type: form.type,
      value: unmaskCurrency(form.value),
      startDate: form.startDate,
      endDate: form.endDate,
      status: "ativo",
      services: form.services,
      notes: form.notes,
      renewalDate: form.renewalDate || "",
      createdAt: getToday(),
    };
    setContracts((prev) => [...prev, contract]);
    setForm({ clientId: "", type: "mensal", value: "", startDate: "", endDate: "", services: [], notes: "", renewalDate: "" });
    onClose();
  };

  if (!open) return null;

  return (
    <Modal open={open} onClose={onClose} title="Novo Contrato" w={520}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 12px" }}>
        <div style={{ gridColumn: "1/-1" }}>
          <Field label="Cliente (Ganho)" required>
            <select style={selectStyle} value={form.clientId} onChange={(e) => setForm((p) => ({ ...p, clientId: e.target.value }))}>
              <option value="">Selecione um cliente ganho...</option>
              {wonClients.map((c) => (
                <option key={c.id} value={c.id}>{c.company}</option>
              ))}
            </select>
          </Field>
        </div>

        <Field label="Tipo" required>
          <select style={selectStyle} value={form.type} onChange={(e) => setForm((p) => ({ ...p, type: e.target.value }))}>
            <option value="mensal">Mensal</option>
            <option value="semestral">Semestral</option>
            <option value="anual">Anual</option>
          </select>
        </Field>

        <Field label="Valor Mensal (R$)" required>
          <input
            style={inputStyle}
            value={form.value}
            onChange={(e) => setForm((p) => ({ ...p, value: maskCurrency(e.target.value) }))}
            placeholder="0,00"
          />
        </Field>

        <Field label="Data Início" required>
          <input style={inputStyle} type="date" value={form.startDate} onChange={(e) => setForm((p) => ({ ...p, startDate: e.target.value }))} />
        </Field>

        <Field label="Data Vencimento" required>
          <input style={inputStyle} type="date" value={form.endDate} onChange={(e) => setForm((p) => ({ ...p, endDate: e.target.value }))} />
        </Field>

        <Field label="Data de Renovação">
          <input style={inputStyle} type="date" value={form.renewalDate} onChange={(e) => setForm((p) => ({ ...p, renewalDate: e.target.value }))} />
        </Field>

        <div style={{ gridColumn: "1/-1" }}>
          <Field label="Serviços Contratados">
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
              {SERVICES.map((s) => (
                <label key={s.id} style={{
                  display: "flex", alignItems: "center", gap: 4,
                  padding: "4px 10px", borderRadius: 6, fontSize: 11,
                  background: form.services.includes(s.id) ? "#251C5915" : "#f8fafc",
                  border: `1px solid ${form.services.includes(s.id) ? "#251C59" : "#e2e8f0"}`,
                  cursor: "pointer", color: form.services.includes(s.id) ? "#251C59" : "#64748b",
                  fontWeight: form.services.includes(s.id) ? 600 : 400,
                }}>
                  <input
                    type="checkbox"
                    checked={form.services.includes(s.id)}
                    onChange={(e) => {
                      setForm((p) => ({
                        ...p,
                        services: e.target.checked
                          ? [...p.services, s.id]
                          : p.services.filter((x) => x !== s.id),
                      }));
                    }}
                    style={{ display: "none" }}
                  />
                  {s.label}
                </label>
              ))}
            </div>
          </Field>
        </div>

        <div style={{ gridColumn: "1/-1" }}>
          <Field label="Observações">
            <textarea
              style={{ ...inputStyle, minHeight: 60, resize: "vertical" }}
              value={form.notes}
              onChange={(e) => setForm((p) => ({ ...p, notes: e.target.value }))}
              placeholder="Condições especiais, observações..."
            />
          </Field>
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: 6, marginTop: 12 }}>
        <button onClick={onClose} style={{ padding: "8px 16px", borderRadius: 8, border: "1px solid #e2e8f0", background: "#fff", color: "#64748b", fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>
          Cancelar
        </button>
        <button
          onClick={handleSave}
          disabled={!form.clientId || !form.startDate || !form.endDate}
          style={{
            padding: "8px 16px", borderRadius: 8, border: "none",
            background: !form.clientId || !form.startDate || !form.endDate ? "#94a3b8" : "#251C59",
            color: "#fff", fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: "inherit",
          }}
        >
          Criar Contrato
        </button>
      </div>
    </Modal>
  );
}
